// Indian Rupee formatting helpers

const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 2,
});

const inrNumberFormatter = new Intl.NumberFormat("en-IN", {
  maximumFractionDigits: 2,
});

export const formatINR = (value) => {
  const n = Number(value || 0);
  return inrFormatter.format(n);
};

export const formatNumber = (value) => {
  const n = Number(value || 0);
  return inrNumberFormatter.format(n);
};

export const parseNumber = (v) => {
  if (v === "" || v === null || v === undefined) return 0;
  const n = parseFloat(v);
  return isNaN(n) ? 0 : n;
};

export const todayISO = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const DENOMINATIONS = [500, 200, 100, 50, 20, 10, 5, 2, 1];
